/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Api
import { useCreateOffset } from '@features/offsets/api/create-offset';

// Store
import useStore from '@store/index';

// Dayjs
import dayjs from 'dayjs';

/* -------------------------------------------------------------------------- */
/*                                  Hook                                      */
/* -------------------------------------------------------------------------- */
export function useOffsetCreation(): {
	handleConfirmCreateOffset: () => void;
	isLoading: boolean;
} {
	/* ********************************** Hooks ********************************* */

	const {
		offsetCreationDatas,
		offsetProjectMixinAco2,
		offsetProjectMixinAddi,
		setSuccessModalOpened,
	} = useStore();

	const createOffset = useCreateOffset();

	/* ********************************** helpers ********************************* */

	const handleConfirmCreateOffset = () => {
		try {
			const { name, brand, startDate, endDate } =
				offsetCreationDatas;

			const isSameDates =
				dayjs(startDate).isSame(endDate);

			const newStartDate =
				dayjs(startDate).format('YYYY-MM-DD');

			const newEndDate = dayjs(endDate)
				.add(isSameDates ? 1 : 0, 'day')
				.format('YYYY-MM-DD');

			const bodyCreateOffset = {
				name,
				entity: brand,
				startDate: new Date(newStartDate),
				endDate: new Date(newEndDate),
				projectMixin_aco2:
					offsetProjectMixinAco2.projectMixin_aco2,
				projectMixin_addi:
					offsetProjectMixinAddi.projectMixin_addi,
				tags: offsetCreationDatas.tags,
			};
			createOffset.mutate(bodyCreateOffset);
		} catch (error) {
			console.log(
				'handleConfirmCreateOffset error ',
				error
			);
		}
	};

	return {
		handleConfirmCreateOffset,
		isLoading: createOffset.isLoading,
	};
}
